export const addresses = {
  tokenGate: "0xD601E7E7138EDAfdC4FE9D2e3c7E8827D648DcEb",
};
